import { useMsal } from '@azure/msal-react';
import { usersApi } from '@/users/services/usersApi';

export default function useLogout() {
  const { instance } = useMsal();
  const [revokeUserSession] = usersApi.useRevokeUserSessionMutation();

  return async () => {
    await revokeUserSession();
    void instance.logoutRedirect();
  };
}
